module.exports = __webpack_public_path__ + "static/img/card_2.1479720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/survery/card_2.png
// module id = 4jEZ
// module chunks = 1